import { render, staticRenderFns } from "./Respiratorymidwifery.vue?vue&type=template&id=160cb686&scoped=true&"
import script from "./Respiratorymidwifery.vue?vue&type=script&lang=js&"
export * from "./Respiratorymidwifery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160cb686",
  null
  
)

export default component.exports